import {
  InputLabel,
  MenuItem,
  FormControl,
  Select,
  TextField,
  styled,
} from '@mui/material'
import { Goal } from 'Generated/graphql-types'
import { purposes, audiences } from '../StoryAiCopy'
import { AiGoalsStoryInput, AiStoryInput } from '../StoryAiTypes'

interface InputProps {
  aiInput: AiStoryInput | AiGoalsStoryInput
  handleFocusChange: (input: string) => void
  handleChange: (value: string, key: string) => void
}

interface GoalInputProps extends InputProps {
  goalArray: Goal[]
}

export const AdditionalRequestsInput = ({
  aiInput,
  handleChange,
  handleFocusChange,
}: InputProps) => (
  <StyledFormControl>
    <StyledTextField
      label='Optional additional requests'
      name='additionalRequests'
      aria-describedby='expl-additionalRequests'
      variant='outlined'
      value={aiInput.additionalRequests}
      onFocus={() => handleFocusChange('additionalRequests')}
      onChange={(event: any) =>
        handleChange(event.target.value, 'additionalRequests')
      }
      InputProps={{
        rows: 1,
        multiline: true,
        inputComponent: 'textarea',
      }}
    />
  </StyledFormControl>
)

export const PurposeInput = ({
  aiInput,
  handleChange,
  handleFocusChange,
}: InputProps) => (
  <StyledFormControl>
    <InputLabel
      id='purpose-label'
      variant='outlined'
      style={{ fontSize: '14px', lineHeight: '14px' }}
      required
    >
      What is the purpose of this story?
    </InputLabel>
    <StyledSelect
      name='purpose'
      labelId='purpose-label'
      id='purpose-select'
      label='purpose'
      required
      aria-describedby='expl-purpose'
      value={aiInput.purpose || ''}
      placeholder='e.g. Provide an update'
      onChange={(event: any) => handleChange(event.target.value, 'purpose')}
      onFocus={() => handleFocusChange('purpose')}
    >
      {purposes.map((purpose: { value: string; text: string }) => (
        <MenuItem value={purpose.value} key={purpose.value}>
          {purpose.text}
        </MenuItem>
      ))}
    </StyledSelect>
  </StyledFormControl>
)

export const AudienceInput = ({
  aiInput,
  handleChange,
  handleFocusChange,
}: InputProps) => (
  <StyledFormControl>
    <InputLabel
      id='audience-label'
      variant='outlined'
      required
      style={{ fontSize: '14px', lineHeight: '14px' }}
    >
      Who is your audience?
    </InputLabel>
    <StyledSelect
      name='audience'
      labelId='audience-label'
      id='audience-select'
      aria-describedby='expl-audience'
      label='Audience'
      required
      value={aiInput.audience || ''}
      placeholder='e.g. Grantmakers'
      onChange={(event: any) => handleChange(event.target.value, 'audience')}
      onFocus={() => handleFocusChange('audience')}
    >
      {audiences.map((audience: { value: string; text: string }) => (
        <MenuItem value={audience.value} key={audience.value}>
          {audience.text}
        </MenuItem>
      ))}
    </StyledSelect>
  </StyledFormControl>
)

export const GoalInput = ({
  aiInput,
  handleChange,
  handleFocusChange,
  goalArray,
}: GoalInputProps) => (
  <StyledFormControl>
    <InputLabel
      id='goal-label'
      variant='outlined'
      required
      style={{ fontSize: '14px', lineHeight: '16px' }}
    >
      Select from your existing goal list
    </InputLabel>
    <StyledSelect
      name='goal'
      labelId='goal-label'
      id='goal-select'
      aria-describedby='expl-goal'
      label='Goal'
      required
      value={(aiInput as AiGoalsStoryInput).goal || ''}
      onChange={(event: any) => handleChange(event.target.value, 'goal')}
      onFocus={() => handleFocusChange('goal')}
    >
      {goalArray.map((goal: Goal) => (
        <MenuItem
          value={goal.id}
          key={goal.id}
          style={{ whiteSpace: 'normal', maxWidth: '502px' }}
        >
          {goal.title}
        </MenuItem>
      ))}
    </StyledSelect>
  </StyledFormControl>
)
export const ImpactInput = ({
  aiInput,
  handleChange,
  handleFocusChange,
}: InputProps) => (
  <StyledFormControl>
    <StyledTextField
      label='Describe your impact'
      name='impact'
      required
      variant='outlined'
      aria-describedby='expl-impact'
      value={(aiInput as AiStoryInput).impact}
      onFocus={() => handleFocusChange('impact')}
      onChange={(event: any) => handleChange(event.target.value, 'impact')}
      InputProps={{
        rows: 5,
        multiline: true,
        inputComponent: 'textarea',
      }}
    />
  </StyledFormControl>
)

export const ImportanceInput = ({
  aiInput,
  handleChange,
  handleFocusChange,
}: InputProps) => (
  <StyledFormControl>
    <StyledTextField
      label='Why is this impact important?'
      name='importance'
      required
      variant='outlined'
      aria-describedby='expl-importance'
      value={(aiInput as AiStoryInput).importance}
      onFocus={() => handleFocusChange('importance')}
      onChange={(event: any) => handleChange(event.target.value, 'importance')}
      InputProps={{
        rows: 3,
        multiline: true,
        inputComponent: 'textarea',
      }}
    />
  </StyledFormControl>
)

export const StyledSelect = styled(Select)`
  & .MuiSelect-select {
    padding: 12px;
    max-width: 414px;
  }
  & .MuiInputLabel-root {
    font-size: 14px;
    line-height: 14px;
  }
`

export const StyledTextField = styled(TextField)`
  & .MuiOutlinedInput-root {
    padding: 0;
  }
  & textarea {
    padding: 12px 12px;
  }

  & .MuiInputLabel-root {
    font-size: 14px;
    line-height: 14px;
  }
`
export const StyledFormControl = styled(FormControl)`
  margin-top: 20px;
`
